var VERSION = 1773307907123

export  {
	VERSION
} 
